import http from '../../../utils/http';
import {
  ForumMembersReportFormDataInterface,
  ResetPasswordFormDataInterface,
} from './forumMembers.types';

class ForumMembersApi {
  getForumMembers = async ({
    page = 1,
    searchTerm,
    regions,
    status = 1,
    organization,
  }: {
    page?: number;
    searchTerm?: string;
    regions?: string[];
    status?: 0 | 1 | 2;
    organization?: string;
  }) => {
    const params = new URLSearchParams();

    if (page) {
      params.append('page', page.toString());
    }

    if (searchTerm) {
      params.append('name', searchTerm);
    }

    if (regions && Array.isArray(regions)) {
      regions.forEach((region) => {
        params.append('regionIds[]', region);
      });
    }

    if (organization) {
      params.append('organizationIds[]', organization);
    }

    params.append('status', String(status));

    const url = `/users${params.toString() ? `?${params.toString()}` : ''}`;

    return http.get(url);
  };

  getForumMember = async (id?: number) => {
    if (id) {
      return http.get(`/users/${id}`);
    }
    return http.get('/myprofile');
  };

  getForumMemberAvatar = async (id: number) => {
    return http.get(`/users/${id}/avatar`, { responseType: 'blob' });
  };

  setForumMemberAvatar = async (id: number, payload: any) => {
    return http.post(`/users/${id}/avatar`, payload);
  };

  addForumMember = async (payload: any) => {
    return http.post('/users', payload);
  };

  updateForumMember = async ({
    id,
    payload,
  }: {
    id?: number;
    payload: any;
  }) => {
    if (id) {
      return http.post(`/users/${id}`, payload);
    }

    return http.post(`/myprofile`, payload);
  };

  deleteForumMember = async (id: number) => {
    return http.delete(`/users/${id}`);
  };

  setForumMemberRoles = async (id: number, data: any) => {
    return http.post(`/users/${id}/roles`, { roleIds: data });
  };

  getForumMemberRole = async (id: number) => {
    return http.get(`/users/${id}/roles`);
  };

  setNewPassword = async (data: ResetPasswordFormDataInterface) => {
    return http.post(`/users/resetpassword`, data);
  };

  activateMember = ({ id }: { id: number }) => {
    return http.post(`/users/${id}/activate`);
  };

  sendActivationEmail = ({ id }: { id: number }) => {
    return http.post(`/users/activationemail`, { id });
  };

  // Get Forum Member Report
  async getForumMembersReport(payload: ForumMembersReportFormDataInterface) {
    const params = new URLSearchParams();

    params.append('status', payload.status.toString());

    if (payload.organization) {
      params.append('organizationIds[]', payload.organization.toString());
    }

    if (payload.searchTerm?.trim()) {
      params.append('name', payload.searchTerm.trim());
    }

    return http.get(`/users/report`, {
      responseType: 'blob',
      params, // Pass the FormData as query parameters
    });
  }
}

export default ForumMembersApi;
